export const BRAND = {
  name: "Ody Luxurious Spa",
  shortName: "ODY",
  tagline: "Luxury Spa in Manikonda, Hyderabad",
  address:
    "9,10, M/s North East Construction, First floor, Plot No. 8, Pipe Line Road, beside RajShree Jewellers, Rajender Nagar, Manikonda, Hyderabad, Telangana 500089",
  addressShort: "Pipe Line Road, Rajender Nagar, Manikonda, Hyderabad",
  phoneDisplay: "+91 90147 29756",
  phoneClean: "+919014729756",
  tel: "tel:+919014729756",
  whatsapp: "https://wa.me/919014729756",
  maps: "https://maps.app.goo.gl/dMsvTUQ23au3Ts4LA",
};

export const waLink = (serviceName) =>
  `https://wa.me/919014729756?text=${encodeURIComponent(
    serviceName
      ? `Hi Ody Luxurious Spa, I would like to inquire about ${serviceName}`
      : "Hi Ody Luxurious Spa, I would like to book a session"
  )}`;

const img = (id, w = 900) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=75`;

export const IMAGES = {
  hero: img("photo-1540555700478-4be289fbecef", 1600),
  relaxation: img("photo-1620733723572-11c53f73a416", 1200),
  ambience2: img("photo-1507652313519-d4e9174996dd", 1200),
  massageCta: img("photo-1787651343620-8d5303006ecb", 1400),
  aboutInterior: img("photo-1693578538512-fc66f318c833", 1200),
  aboutTherapist: img("photo-1624454002302-36b824d7bd0a"),
};

export const CATEGORIES = [
  {
    slug: "massages",
    name: "Massages",
    eyebrow: "The Classics",
    tagline: "Time-honoured therapies, mastered",
    description:
      "Five world traditions of touch — from the long gliding strokes of Sweden to the acupressure lines of Bali — each performed by certified therapists in candle-lit private suites.",
    image: img("photo-1620733723572-11c53f73a416"),
  },
  {
    slug: "premium-massages",
    name: "Premium Collection",
    eyebrow: "The Signature Collection",
    tagline: "Rare therapies, crafted for indulgence",
    description:
      "Our most coveted experiences — molten chocolate, warm candle elixirs, red wine antioxidants and synchronised four-hand choreography. This is where Ody becomes unforgettable.",
    image: img("photo-1603274737277-f43f54446c7b"),
  },
  {
    slug: "reflexology-scrubs",
    name: "Reflexology & Scrubs",
    eyebrow: "Renewal",
    tagline: "Ground, polish, renew",
    description:
      "Ancient pressure-point foot therapies and full-body exfoliation that buff away fatigue and dull skin, leaving you lighter from sole to shoulder.",
    image: img("photo-1519415510236-718bdfcd89c8"),
  },
  {
    slug: "wraps-facials",
    name: "Wraps & Facials",
    eyebrow: "Radiance",
    tagline: "Skin, wrapped in luxury",
    description:
      "Warm herbal cocooning and our showpiece 24K gold facial — treatments that detoxify, firm and leave skin luminous long after you leave.",
    image: img("photo-1540555700478-4be289fbecef"),
  },
  {
    slug: "jacuzzi",
    name: "Jacuzzi",
    eyebrow: "Hydrotherapy",
    tagline: "Warm water, total privacy",
    description:
      "Sink into a private jacuzzi suite where warm hydrotherapy jets melt residual tension — alone, or side by side with someone special.",
    image: img("photo-1507652313519-d4e9174996dd"),
  },
];

const MASSAGE_DURATION = "45 / 60 / 90 / 120 minutes";

export const SERVICES = [
  {
    slug: "swedish",
    category: "massages",
    name: "Swedish Massage",
    tagline: "Classic strokes, total release",
    duration: MASSAGE_DURATION,
    image: img("photo-1787651343620-8d5303006ecb"),
    excerpt:
      "The world's most loved massage — long, gliding strokes that dissolve tension and restore calm.",
    description: [
      "The Swedish massage is the foundation of Western spa therapy, and at Ody it is performed the way it was meant to be — unhurried, rhythmic and deeply intuitive. Your therapist works with effleurage, kneading and gentle friction to warm the muscles and guide the body out of its held tensions.",
      "Pressure is tailored entirely to you, from feather-light to firm. Expect improved circulation, a quieter nervous system and the kind of sleep that night that reminds you what rest actually feels like.",
    ],
    benefits: ["Improves blood circulation", "Eases muscle tension", "Calms the nervous system", "Promotes deep, restful sleep"],
    ideal: "First-time spa guests and anyone carrying everyday stress.",
  },
  {
    slug: "aroma",
    category: "massages",
    name: "Aroma Massage",
    tagline: "Botanical oils, whispered calm",
    duration: MASSAGE_DURATION,
    image: img("photo-1624454002302-36b824d7bd0a"),
    excerpt:
      "A sensory massage layered with pure essential oils chosen for your mood — lavender, eucalyptus, rose.",
    description: [
      "Aroma massage pairs the gentle choreography of a relaxation massage with the therapeutic intelligence of pure essential oils. Before your session, your therapist helps you choose a blend — calming lavender, clearing eucalyptus, uplifting citrus or romantic rose.",
      "As the oils warm into the skin, their aromatic compounds work on both body and mind. Breathing slows, shoulders drop, and the scent lingers softly for hours after — a signature you carry home.",
    ],
    benefits: ["Reduces anxiety & mental fatigue", "Nourishes skin with botanical oils", "Balances mood through aromatherapy", "Relieves headaches & stiffness"],
    ideal: "Anyone seeking emotional unwinding alongside physical relief.",
  },
  {
    slug: "thai",
    category: "massages",
    name: "Thai Massage",
    tagline: "Ancient stretches, renewed energy",
    duration: MASSAGE_DURATION,
    image: img("photo-1619695662967-3e739a597f47"),
    excerpt:
      "Assisted stretches and acupressure that open the body without a drop of oil.",
    description: [
      "Rooted in a 2,500-year-old healing tradition, Thai massage is performed without oils on a comfortable floor mat. Your therapist uses palms, thumbs, elbows and gentle body weight to guide you through a sequence of assisted stretches and acupressure along the body's energy lines.",
      "The result is unlike any oil massage — you stand up feeling taller, looser and strangely energised, as if someone untied knots you forgot you had.",
    ],
    benefits: ["Improves flexibility & posture", "Releases deep muscular knots", "Boosts energy flow", "Relieves back & hip tightness"],
    ideal: "Desk-bound professionals and anyone who feels stiff or compressed.",
  },
  {
    slug: "deep-tissue",
    category: "massages",
    name: "Deep Tissue Massage",
    tagline: "Firm pressure, profound relief",
    duration: MASSAGE_DURATION,
    image: img("photo-1791083046386-409d735a96e0"),
    excerpt:
      "Slow, deliberate pressure into the deeper muscle layers — built for chronic aches and sports strain.",
    description: [
      "Deep tissue is therapy with intent. Using slow strokes, forearms and focused finger pressure, your therapist works past the surface muscles into the deeper layers where chronic tension, old injuries and postural strain actually live.",
      "It is firmer than a relaxation massage — honest, effective pressure that may challenge you in the moment and reward you for days. Ideal for gym-goers, athletes and anyone whose shoulders have forgotten how to soften.",
    ],
    benefits: ["Releases chronic muscle tension", "Aids recovery from sports strain", "Breaks down adhesions & knots", "Improves mobility & range of motion"],
    ideal: "Athletes, gym-goers and chronic back or neck pain sufferers.",
  },
  {
    slug: "balinese",
    category: "massages",
    name: "Balinese Massage",
    tagline: "Island tradition, flowing grace",
    duration: MASSAGE_DURATION,
    image: img("photo-1760507971904-9b0fbef6abb3"),
    excerpt:
      "Bali's healing gift — acupressure, skin rolling and aromatherapy woven into one flowing session.",
    description: [
      "Born in the healing villages of Bali, this massage weaves together gentle stretches, acupressure, skin rolling and long flowing strokes with fragrant coconut and frangipani oils. It is both deeply relaxing and quietly therapeutic.",
      "The rhythm is the secret — continuous, wave-like movements that lull the mind while the pressure points do their work. Many guests call it the most complete massage they have ever had.",
    ],
    benefits: ["Harmonises body & mind", "Stimulates lymphatic drainage", "Deeply hydrates the skin", "Relieves stress & insomnia"],
    ideal: "Those who want therapeutic depth with a gentle, flowing touch.",
  },
  {
    slug: "chocolate",
    category: "premium-massages",
    name: "Chocolate Massage",
    tagline: "Molten cocoa, pure decadence",
    duration: MASSAGE_DURATION,
    image: img("photo-1558839653-17f53527c41b"),
    excerpt:
      "Warm melted chocolate massaged into the skin — antioxidant-rich indulgence you can feel.",
    description: [
      "Our most playful signature. Warm, molten cocoa — rich in antioxidants and natural moisturisers — is poured and massaged across the body in slow, indulgent strokes. The aroma alone triggers the brain's pleasure centres before the therapy even begins.",
      "Cocoa butter leaves the skin silk-soft and visibly nourished, while the massage itself melts stress away. It is dessert for the senses, with none of the guilt.",
    ],
    benefits: ["Deeply moisturises & softens skin", "Antioxidant-rich cocoa therapy", "Elevates mood naturally", "Relieves stress & fatigue"],
    ideal: "Celebrations, gifts and anyone who believes luxury should be fun.",
  },
  {
    slug: "melting-candle",
    category: "premium-massages",
    name: "Melting Candle Therapy",
    tagline: "Warm wax elixir, candlelit calm",
    duration: MASSAGE_DURATION,
    image: img("photo-1554057009-6798cb3d4a04"),
    excerpt:
      "A massage candle melts into a warm, fragrant oil that is drizzled and massaged into the skin.",
    description: [
      "An experience as beautiful as it sounds. A specially crafted massage candle burns low beside the table, melting into a pool of warm, fragrant body oil — a blend of shea butter, soy and essential oils heated to the perfect skin temperature.",
      "Your therapist drizzles the warm elixir along the spine and limbs, then massages it in with long, enveloping strokes. The warmth penetrates deeper than any room-temperature oil ever could.",
    ],
    benefits: ["Warm oil penetrates deeper muscles", "Intensely hydrating for dry skin", "Multi-sensory candlelit experience", "Profound relaxation response"],
    ideal: "Winter evenings, anniversaries and deep relaxation seekers.",
  },
  {
    slug: "spearmint-oil",
    category: "premium-massages",
    name: "Spearmint Oil Therapy",
    tagline: "Cool clarity, invigorated senses",
    duration: MASSAGE_DURATION,
    image: img("photo-1556118903-08e0b48041fc"),
    excerpt:
      "Cooling spearmint oil worked into tired muscles — the reset button for Hyderabad's heat.",
    description: [
      "Spearmint oil therapy is our answer to long days and hot city air. Cool-pressed spearmint essential oil is blended into a light carrier oil and massaged with invigorating strokes that wake up sluggish circulation.",
      "The menthol coolness spreads gently across the skin — soothing headaches, refreshing the mind and leaving the whole body feeling freshly aired. Guests walk out noticeably lighter and sharper.",
    ],
    benefits: ["Cooling relief for tired muscles", "Clears the mind & eases headaches", "Stimulates circulation", "Naturally refreshes & deodorises skin"],
    ideal: "Hot afternoons, jet lag and mental fog.",
  },
  {
    slug: "red-wine-exotic",
    category: "premium-massages",
    name: "Red Wine Exotic Therapy",
    tagline: "Vineyard luxury for your skin",
    duration: MASSAGE_DURATION,
    image: img("photo-1510812431401-41d2bd2722f3"),
    excerpt:
      "Antioxidant-rich red wine extracts massaged into the skin — the anti-ageing secret of the vines.",
    description: [
      "Borrowed from the vinotherapy spas of Bordeaux, this exotic therapy uses red wine extracts — among nature's richest sources of polyphenols and resveratrol — blended into a silky massage medium.",
      "As the therapist works, the antioxidants absorb into the skin, fighting free radicals and encouraging a firmer, more radiant complexion. It is indulgence with a genuinely restorative edge.",
    ],
    benefits: ["Powerful antioxidant skin therapy", "Promotes firmness & elasticity", "Luxurious aromatic experience", "Rejuvenates dull, tired skin"],
    ideal: "Skin-conscious guests and lovers of the finer things.",
  },
  {
    slug: "four-hand",
    category: "premium-massages",
    name: "Four Hand Massage",
    tagline: "Two therapists, one rhythm",
    duration: "60 / 90 / 120 minutes",
    image: img("photo-1693578538512-fc66f318c833"),
    excerpt:
      "Two therapists move in perfect synchrony — a choreographed massage the mind cannot track, only feel.",
    description: [
      "The four hand massage is the pinnacle of massage craft. Two therapists work in mirrored synchrony, their strokes choreographed so precisely that the brain gives up trying to follow — and surrenders completely.",
      "What a single pair of hands achieves in ninety minutes, four achieve with double the depth and a strange, weightless calm. It is the treatment our regulars describe in whispers and book again before they leave.",
    ],
    benefits: ["Twice the therapeutic coverage", "Deeper mental surrender", "Synchronised rhythmic flow", "The ultimate spa indulgence"],
    ideal: "Connoisseurs, milestone celebrations and the hardest-to-relax minds.",
  },
  {
    slug: "ody-couple",
    category: "premium-massages",
    name: "ODY Couple Massage",
    tagline: "Our signature, shared",
    duration: MASSAGE_DURATION,
    image: img("photo-1791083046386-409d735a96e0"),
    excerpt:
      "Two tables, two therapists, one private suite — our signature experience designed for two.",
    description: [
      "The ODY Couple Massage is our namesake experience. In a private couple suite lit by candlelight, two therapists deliver synchronised massages side by side — each tailored to the individual, yet flowing together as one shared session.",
      "Choose your preferred style for each of you — Swedish, Balinese or Aroma — and let the suite do the rest. It ends, as all good evenings should, with nowhere to rush to.",
    ],
    benefits: ["Private couple suite experience", "Individually tailored pressure", "Synchronised side-by-side session", "Perfect for anniversaries & dates"],
    ideal: "Couples celebrating something — or nothing at all.",
  },
  {
    slug: "foot-reflexology",
    category: "reflexology-scrubs",
    name: "Foot Reflexology",
    tagline: "Whole-body calm, through the feet",
    duration: null,
    image: img("photo-1519415510236-718bdfcd89c8"),
    excerpt:
      "Ancient pressure-point therapy that maps the entire body onto the soles of your feet.",
    description: [
      "Reflexology rests on a simple, ancient idea: every organ and system of the body is mapped onto points in the feet. Your therapist works these points with precise thumb pressure, releasing blockages and encouraging the body's own healing response.",
      "It begins with a warm herbal foot soak and ends with you wondering how so much relief could come from so small a canvas. Regulars swear by it for sleep, digestion and that heavy-legged city fatigue.",
    ],
    benefits: ["Stimulates whole-body healing points", "Relieves foot & leg fatigue", "Improves sleep quality", "Includes warm herbal foot soak"],
    ideal: "Those on their feet all day, and anyone wary of full-body massage.",
  },
  {
    slug: "full-body-scrub",
    category: "reflexology-scrubs",
    name: "Full Body Scrub",
    tagline: "Polished, buffed, reborn",
    duration: null,
    image: img("photo-1627435601993-29a3fb48dd44"),
    excerpt:
      "Gentle exfoliation with natural scrubs that lift away dull skin and reveal the glow beneath.",
    description: [
      "Skin renews itself constantly — a full body scrub simply hurries the process along. Using natural exfoliants blended with nourishing oils, your therapist buffs away dead cells in long, invigorating strokes across the entire body.",
      "Circulation surges, pores clear, and what emerges is skin that feels like new — softer, brighter and ready to drink in moisture. Many guests pair it with a massage for the complete reset.",
    ],
    benefits: ["Removes dead skin & impurities", "Boosts circulation & glow", "Prepares skin for deep hydration", "Natural, skin-kind exfoliants"],
    ideal: "Pre-event glow-ups and monthly skin maintenance.",
  },
  {
    slug: "herbal-body-wrap",
    category: "wraps-facials",
    name: "Herbal Body Wrap",
    tagline: "Cocooned in botanicals",
    duration: null,
    image: img("photo-1558394299-f2e6198506a6"),
    excerpt:
      "A warm herbal masque painted over the body, then wrapped snugly while the botanicals do their work.",
    description: [
      "The herbal body wrap is quiet, profound therapy. A warm masque of healing herbs, clays and oils is smoothed over the body before you are wrapped snugly, cocooned in warmth while the botanicals draw out impurities and feed the skin.",
      "As you rest, your therapist treats you to a gentle scalp massage. You emerge noticeably softer — in skin and in spirit.",
    ],
    benefits: ["Detoxifies & purifies skin", "Deeply nourishing herbal masque", "Includes soothing scalp massage", "Leaves skin supple & toned"],
    ideal: "Detox seekers and anyone whose skin feels tired of the city.",
  },
  {
    slug: "24k-gold-facial",
    category: "wraps-facials",
    name: "24K Gold Facial",
    tagline: "Royalty, worn on the skin",
    duration: null,
    image: img("photo-1603274737277-f43f54446c7b"),
    excerpt:
      "Our showpiece facial — genuine 24K gold leaf and elixirs for a luminosity no filter can match.",
    description: [
      "Cleopatra reportedly slept in a gold mask; we simply perfected the idea. Our 24K Gold Facial layers genuine gold leaf and gold-infused serums over a deep cleanse, exfoliation and lymphatic facial massage.",
      "Gold is prized in skincare for stimulating collagen, calming inflammation and imparting an unmistakable lit-from-within glow. This is the treatment before weddings, photographs and evenings that matter.",
    ],
    benefits: ["Genuine 24K gold leaf therapy", "Stimulates collagen & radiance", "Deep cleanse + lymphatic massage", "Red-carpet luminosity"],
    ideal: "Brides, grooms and big occasions — or simply because.",
  },
  {
    slug: "private-jacuzzi",
    category: "jacuzzi",
    name: "Private Jacuzzi Session",
    tagline: "Warm water, yours alone",
    duration: null,
    image: img("photo-1682906159394-a9912cb007b2"),
    excerpt:
      "A private jacuzzi suite with warm hydrotherapy jets — booked solo, enjoyed in total privacy.",
    description: [
      "Sometimes luxury is simply warm water and no interruptions. Our private jacuzzi suite is booked for you alone — soft lighting, warm hydrotherapy jets working tired muscles, and a door that stays closed until you say otherwise.",
      "Add it before a massage to loosen the body, or book it as an experience unto itself. Towels, toiletries and tranquillity are, of course, provided.",
    ],
    benefits: ["Completely private suite", "Hydrotherapy jets ease muscles", "Perfect pre-massage warm-up", "Fresh towels & amenities included"],
    ideal: "Solo unwinders and anyone craving an hour of absolute quiet.",
  },
  {
    slug: "couple-jacuzzi",
    category: "jacuzzi",
    name: "Couple Jacuzzi Experience",
    tagline: "Steam, bubbles, just you two",
    duration: null,
    image: img("photo-1781455495229-c4014d76b5ad"),
    excerpt:
      "A candlelit private jacuzzi for two — the most requested hour in the house.",
    description: [
      "The couple jacuzzi is our most requested experience for a reason. A private suite, warm bubbling water, soft candlelight and absolutely no one else — just the two of you and an hour that belongs entirely to you.",
      "Pair it with the ODY Couple Massage for the full signature evening. Anniversaries, proposals and ordinary Tuesdays have all been made memorable here.",
    ],
    benefits: ["Private candlelit couple suite", "Warm hydrotherapy for two", "Pairs perfectly with couple massage", "Anniversary & proposal favourite"],
    ideal: "Couples marking a moment — or making one.",
  },
];

export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
export const getService = (categorySlug, serviceSlug) =>
  SERVICES.find((s) => s.category === categorySlug && s.slug === serviceSlug);
export const servicesByCategory = (slug) => SERVICES.filter((s) => s.category === slug);

export const REVIEWS = [
  {
    name: "Ananya Reddy",
    service: "Swedish Massage",
    text: "The most calming ninety minutes I've had in years. The suite was spotless, the therapist asked about pressure preferences before starting, and I walked out feeling ten kilos lighter. Manikonda finally has a proper luxury spa.",
  },
  {
    name: "Rohit Sharma",
    service: "Deep Tissue Massage",
    text: "I train six days a week and carry serious shoulder tension. The deep tissue work here is genuinely therapeutic — not the superficial kind you get elsewhere. Booked my next session before I left.",
  },
  {
    name: "Priya & Karthik Nair",
    service: "ODY Couple Massage",
    text: "We came for our anniversary and the couple suite was beautiful — candlelight, soft music, two therapists perfectly in sync. It felt private and personal, not commercial. Worth every bit of the hype.",
  },
  {
    name: "Sneha Kulkarni",
    service: "24K Gold Facial",
    text: "Had the gold facial two days before my engagement and my skin has never looked better. The glow lasted over a week. The staff never once rushed me. This place understands luxury.",
  },
  {
    name: "Imran Sheikh",
    service: "Foot Reflexology",
    text: "On my feet twelve hours a day for work. One reflexology session here and the heaviness was gone — slept like a baby that night. The herbal foot soak at the start is a lovely touch.",
  },
  {
    name: "Divya Menon",
    service: "Chocolate Massage",
    text: "Booked the chocolate massage as a birthday treat and it was pure indulgence. Smelled incredible, skin felt like silk afterwards. The hygiene standards genuinely impressed me — everything fresh and sanitised.",
  },
  {
    name: "Arjun Patel",
    service: "Couple Jacuzzi Experience",
    text: "Surprised my wife with the couple jacuzzi and it was the highlight of our month. Completely private suite, warm bubbles, candles everywhere. Booking on WhatsApp took two minutes.",
  },
  {
    name: "Lakshmi Venkat",
    service: "Four Hand Massage",
    text: "Four hands moving in perfect rhythm is something you have to feel to believe. My mind simply switched off — that never happens. The most unique massage in Hyderabad, without question.",
  },
];

export const FAQS = [
  {
    q: "Where exactly is Ody Luxurious Spa located?",
    a: "We are on the first floor at Plot No. 8, Pipe Line Road, beside RajShree Jewellers, Rajender Nagar, Manikonda, Hyderabad, Telangana 500089. Tap the directions button on our contact page for turn-by-turn navigation.",
  },
  {
    q: "How do I book a session?",
    a: "Call us on +91 90147 29756 or message us on WhatsApp — the booking form on our contact page sends your request straight to our WhatsApp. Our team will confirm your preferred therapy, therapist and time slot.",
  },
  {
    q: "Do you show prices on the website?",
    a: "We keep our service pricing personal — call or WhatsApp us and we will share the current rate card and any seasonal offers. Membership plan prices are listed on the Membership page.",
  },
  {
    q: "Do you offer couple massages?",
    a: "Yes. The ODY Couple Massage and Couple Jacuzzi Experience are designed for two, hosted in private couple suites with synchronised therapists.",
  },
  {
    q: "Can I request a male or female therapist?",
    a: "Absolutely. Mention your preference while booking on call or WhatsApp and we will assign your therapist accordingly, subject to availability.",
  },
  {
    q: "What are your hygiene standards?",
    a: "Every suite is sanitised between sessions, linens are single-use and freshly laundered, and all oils and products are sealed and premium-grade. Hygiene is the promise we never compromise on.",
  },
  {
    q: "Do I need an appointment, or can I walk in?",
    a: "We recommend booking ahead — especially on weekends and evenings — but walk-ins are welcome whenever a suite is free. A quick WhatsApp message before you leave home guarantees your slot.",
  },
  {
    q: "How long are the sessions?",
    a: "Massages can be booked for 45, 60, 90 or 120 minutes, and Four Hand sessions start at 60 minutes. Timings for reflexology, scrubs, wraps, facials and jacuzzi experiences are confirmed when you book.",
  },
  {
    q: "What should I wear or bring?",
    a: "Nothing at all. We provide fresh linens, disposable wear, towels, lockers and showers. Simply arrive a few minutes early and let us handle the rest.",
  },
  {
    q: "What are your operating hours?",
    a: "We are open all days of the week. Call or WhatsApp +91 90147 29756 for current timings and same-day availability.",
  },
];

export const HOME_FAQS = FAQS.slice(0, 3);
